import { stateful } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import { insertTestData } from '../../api/test-data.js';

export const TestDataDialog = stateful((props: { onClose: () => void }) => {
  const handleInsertData = async () => {
    try {
      // Call the mutation directly as a function
      const result = await insertTestData()();
      if (result) {
        alert('Test data inserted successfully!');
      } else {
        alert('Failed to insert test data. Check console logs for more information.');
      }
    } catch (error) {
      console.error('Error inserting test data:', error);
      alert(`Error inserting test data: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      props.onClose();
    }
  };

  return html`
    <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div class="bg-base-100 rounded-lg shadow-xl p-6 max-w-md w-full">
        <h2 class="text-xl font-bold mb-4">Insert Test Data</h2>
        <p class="mb-6">
          This will insert test mentors and mentees into the database for testing purposes. Do you want to proceed?
        </p>
        <div class="flex justify-end gap-3">
          <button class="btn btn-outline" @click=${props.onClose}>Cancel</button>
          <button class="btn btn-primary" @click=${handleInsertData}>Insert Test Data</button>
        </div>
      </div>
    </div>
  `;
});
